import React from 'react';
import styled from 'styled-components';
import { isFieldValid } from '../../../utils/validation';
import { RichTextParagraph, Paragraph, BlockQuote } from '../../Typography';
import { BodyTextWithAnimatedValues } from '../../AnimatedValue';
import { CTALink } from '../../Link';
import media from '../../../utils/media';
import { getParsedField } from '../../../utils/helpers';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 80px;
  width: 100%;

  ${media.mobile} {
    padding: 40px 10px 30px 10px;
  }

  *:last-child {
    margin-bottom: 0;
  }
`;
const ContentSubtitle = styled(RichTextParagraph) `
  font-family: ${({ theme }) => theme.fontFamilyHeading};
  font-weight: bold;
  font-size: 34px;
  line-height: 40px;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.primaryRed};
  margin-bottom: 20px;
  width: 100%;

  ${media.mobile} {
    font-size: 22px;
    line-height: 26px;
    margin-bottom: 10px;
  }
`;
const StyledBlockQuote = styled(BlockQuote) `
  width: 100%;
  margin-bottom: 20px;
  ${media.mobile} {
    margin-bottom: 10px;
  }
`;
const LargeContentBodyText = styled(Paragraph) `
  font-family: ${({ theme }) => theme.fontFamilyHeading};
  font-weight: bold;
  font-size: 56px;
  line-height: 65px;
  font-style: italic;

  ${media.mobile} {
    font-size: 32px;
    line-height: 36px;
  }
`;
const ContentBodyText = styled(Paragraph) `
  width: 100%;
  font-size: 26px;
  line-height: 42px;
  margin-bottom: 36px;

  ${media.mobile} {
    font-size: 20px;
    line-height: 36px;
    margin-bottom: 30px;
  }
`;
export const TabTextContent = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const { contentSubtitle, contentLargeBodyText, contentBodyText, contentLargeBodyTextQuote, ctaLink, ctaLinkText, ctaType, } = fields;
    const hasBodyTextQuotes = isFieldValid(contentLargeBodyTextQuote);
    const parsedSubtitle = getParsedField(contentSubtitle);
    return (React.createElement(Container, null,
        isFieldValid(contentSubtitle) && React.createElement(ContentSubtitle, { field: parsedSubtitle }),
        isFieldValid(contentLargeBodyText) && (React.createElement(StyledBlockQuote, null,
            React.createElement(LargeContentBodyText, null,
                hasBodyTextQuotes && React.createElement(React.Fragment, null, "\u201C"),
                contentLargeBodyText.value,
                hasBodyTextQuotes && React.createElement(React.Fragment, null, "\u201D")))),
        isFieldValid(contentBodyText) && (React.createElement(ContentBodyText, null,
            React.createElement(BodyTextWithAnimatedValues, { field: contentBodyText }))),
        isFieldValid(ctaLink, 'href') && isFieldValid(ctaLinkText) && (React.createElement(CTALink, { field: ctaLink, textField: ctaLinkText, typeField: ctaType }))));
};
